module.exports = __webpack_public_path__ + "static/media/genesis_logo_transparent_grey.b4bf53f4.png";